import React, { useMemo } from 'react';
import { ALL_CATEGORIES_FILTER } from '@/utils/category';
import { FilterOption, SplitFilterList } from '@/components/split-filter-list';

export interface CategoryProps {
  categories: string[];
  onCategoryPress: (category: string | null) => void;
  selectedCategory: string | null;
}

export const GTINFilterCategories: React.FC<CategoryProps> = ({
  categories,
  onCategoryPress,
  selectedCategory,
}) => {
  const categoryOptions = useMemo<FilterOption[]>(() => {
    const allOption: FilterOption = {
      metadata: {
        action: () => {
          onCategoryPress?.(null);
        },
        isSelected: selectedCategory === null,
      },
      title: ALL_CATEGORIES_FILTER,
      value: 'SIDE_PANEL_ALL',
    };
    const catOptions = categories.map<FilterOption>((category) => ({
      metadata: {
        action: () => {
          onCategoryPress?.(category);
        },
        isSelected: selectedCategory === category,
      },
      title: category,
      value: category,
    }));
    return [allOption, ...catOptions];
  }, [categories, onCategoryPress, selectedCategory]);

  return categories.length ? <SplitFilterList data={categoryOptions} /> : null;
};
